
const BASE_URL = "https://hephaestus.healthespresso.ca" //FHIR DEV URL
//const BASE_URL = 'https://staging-api.healthespresso.ca' //FHIR STAGING URL
//const BASE_URL = "https://apiv3.healthespresso.ca"; //FHIR PROD URL
//const CLINIC_ID = '19b96358-6972-4b0a-8b1c-f579c96cc279';
const CLINIC_ID = "b922b5bf-096a-49b9-9bbf-9b2e56d7f5b6" // FHIR Dev Clinic
//const CLINIC_ID = '02a3a0f3-8f59-460e-b1e4-0864639664df'; // FHIR Internal Prod Clinic
//const CLINIC_ID = 'eb3e075c-d556-41c4-8157-352a30f8073f'; // NWRVC Clinic


//deprecated endpoint
// export const REVISIT_APPOINTMENT_URL = `${BASE_URL}/ucare-clinic/revisit`
export const REGISTER_PATIENT_URL = `${BASE_URL}/ucare-clinic/v2/register`
export const REGISTER_APPOINTMENT_URL = `${BASE_URL}/public/assign/patients/clinics/${CLINIC_ID}`
export const GET_DOCTORS_URL = `${BASE_URL}/organizations/${CLINIC_ID}/practitioners`
export const DEV_GET_VERIFICATION_STATUS = `https://adirh98wl6.execute-api.ca-central-1.amazonaws.com/check_user?email=` //Dev endpont, change this for staging
//export const DEV_GET_VERIFICATION_STATUS = `https://roooo7xz25.execute-api.ca-central-1.amazonaws.com/default/check_user?email=` //Staging endpoint
export const PROD_GET_VERIFICATION_STATUS = ` https://pyg6cpy3da.execute-api.ca-central-1.amazonaws.com/check_user?email=` //Prod endpoint
export const GET_SERVER_TIME = `${BASE_URL}/server-time`
export const GET_JWT_TOKEN = `${BASE_URL}/users/signin/lite`
export const REVISIT_APPOINTMENT_URL_V2 = `${BASE_URL}/v1/intakes/intake`
export const RESEND_CONFIRMATION_EMAIL = `${BASE_URL}/users/resend-confirmation-code/referral`

export const bloodTypes = [
  { label: "Blood group A", value: "112144000" },
  { label: "Blood group AB", value: "165743006" },
  { label: "Blood group B", value: "112149005" },
  { label: "Blood group O", value: "58460004" },
  { label: "Unknown", value: "unknown" },
]

export const genderIdentityOptions = [
  {
    display: 'Transgender female',
    code: 'transgender-female',
    definition: 'the patient identifies as transgender male-to-female',
  },
  {
    display: 'Transgender male',
    code: 'transgender-male',
    definition: 'the patient identifies as transgender female-to-male',
  },
  {
    display: 'Male',
    code: 'male',
    definition: 'the patient identifies as male',
  },
  {
    display: 'Female',
    code: 'female',
    definition: 'the patient identifies as female',
  },
  {
    display: 'Non-binary',
    code: 'non-binary',
    definition: 'the patient identifies with neither/both female and male',
  },
  { display: 'Other', code: 'other', definition: 'other gender identity' },
  {
    display: 'Does not wish to disclose',
    code: 'non-disclose',
    definition: 'the patient does not wish to disclose his gender identity',
  },
]
export const pronounsOptions = [
  { label: 'They/Them', value: 'they-them' },
  { label: 'She/Her', value: 'she-her' },
  { label: 'He/Him', value: 'he-him' },
]
export const videoOptoutOptions = [
  { label: 'Weak Signal from Provider', value: 'weak-signal' },
  { label: 'Worried About Data Charges', value: 'data-charges' },
  { label: 'No Privacy', value: 'no-privacy' },
  { label: 'Appointment Does Not Require Video', value: 'no-video-required' },
  {
    label: 'Not Comfortable with Technology',
    value: 'not-comfortable-with-technology',
  },
  { label: 'Other', value: 'other' },
]

// "bloodGroup": [
//     {
//         "code": "112144000",
//         "system": "http://snomed.info/sct",
//         "display": "Blood group A"
//     },
//     {
//         "code": "165743006",
//         "system": "http://snomed.info/sct",
//         "display": "Blood group AB"
//     },
//     {
//         "code": "112149005",
//         "system": "http://snomed.info/sct",
//         "display": "Blood group B"
//     },
//     {
//         "code": "58460004",
//         "system": "http://snomed.info/sct",
//         "display": "Blood group O"
//     }
// ]

export const initialDoctor = [
  {
    value: 'no-doctor',
    label: 'No preference',
  },
]

export const initialValues = {
  first_name: '',
  common_name: '',
  last_name: '',
  gender: '',
  gender_identity: '',
  pronouns: '',
  appt_exclude_video: '',
  appt_video_optout_reason: '',
  appt_indigenous: '',
  date_of_birth: '',
  appt_related_last_visit: '',
  // age: "",
  blood_type: '',
  email: '',
  phone_number: '',
  street_address: '',
  province: '',
  city: '',
  postal_code: '',
  regular_family_doctor: '',
  family_doctor_if_yes: '',
  medical_problem: '',
  medical_problem_if_yes: '',
  medications: '',
  medications_if_yes: '',
  allergies: '',
  allergies_if_yes: '',
  preferred_pharmacy: '',
  preferred_pharmacy_if_yes: '',
  referred_by_811: '',
  doctor_contacted: '',
  doctor_contacted_if_yes: '',
  appt_respiratory_illness: '',
  appt_symptom_fever: '',
  appt_shortness_of_breath: '',
  appt_abdominal_pain: '',
  appt_vomiting: '',
  appt_urinary_tract_infection: '',
  appt_rash: '',
  appt_wound_infection: '',
  appt_trauma_or_injury: '',
  appt_earache: '',
  appt_prescription_refill: '',
  appt_follow_up: '',
  appt_sick_note: '',
  appt_primary_care_needs: '',
  appt_please_describe_if_answered_yes: '',
  appt_reason_for_medical_visit_today: '',
  health_card_number: '',
  //   doctor_id: "",
}

export const updateValuesForRevisit = ({
  email,
  password,
  //   doctor_id,
  appt_related_last_visit,
  appt_exclude_video,
  appt_video_optout_reason,
  appt_indigenous,
  appt_respiratory_illness,
  appt_symptom_fever,
  appt_shortness_of_breath,
  appt_abdominal_pain,
  appt_vomiting,
  appt_urinary_tract_infection,
  appt_rash,
  appt_wound_infection,
  appt_trauma_or_injury,
  appt_earache,
  appt_prescription_refill,
  appt_sick_note,
  appt_primary_care_needs,
  appt_please_describe_if_answered_yes,
  appt_reason_for_medical_visit_today,
}) => {
  const updatedValues = {
    email,
    password,
    appt_related_last_visit,
    appt_exclude_video,
    appt_video_optout_reason,
    appt_indigenous,
    // doctor_id: doctor_id === "no-doctor" ? null : doctor_id,
    appt_respiratory_illness,
    appt_symptom_fever,
    appt_shortness_of_breath,
    appt_abdominal_pain,
    appt_vomiting,
    appt_urinary_tract_infection,
    appt_rash,
    appt_wound_infection,
    appt_trauma_or_injury,
    appt_earache,
    appt_prescription_refill,
    appt_sick_note,
    appt_primary_care_needs,
    appt_discharged_from_hospital_in_14days,
    appt_please_describe_if_answered_yes,
    appt_reason_for_medical_visit_today,
    clinic_id: CLINIC_ID,
  }
  return updatedValues
}

export const updateValuesForFirstVisit = ({
  first_name,
  common_name,
  last_name,
  gender,
  gender_identity,
  pronouns,
  appt_exclude_video,
  appt_video_optout_reason,
  appt_indigenous,
  date_of_birth,
  email,
  phone_number,
  street_address,
  province,
  city,
  postal_code,
  //   doctor_id,
  regular_family_doctor,
  family_doctor_if_yes,
  medical_problem,
  medical_problem_if_yes,
  medications,
  medications_if_yes,
  allergies,
  allergies_if_yes,
  preferred_pharmacy,
  preferred_pharmacy_if_yes,
  referred_by_811,
  doctor_contacted,
  doctor_contacted_if_yes,
  appt_respiratory_illness,
  appt_symptom_fever,
  appt_shortness_of_breath,
  appt_abdominal_pain,
  appt_vomiting,
  appt_urinary_tract_infection,
  appt_rash,
  appt_wound_infection,
  appt_trauma_or_injury,
  appt_earache,
  appt_prescription_refill,
  appt_sick_note,
  appt_primary_care_needs,
  appt_discharged_from_hospital_in_14days,
  appt_please_describe_if_answered_yes,
  appt_reason_for_medical_visit_today,
  health_card_number,
}) => {
  const updatedValues = {
    first_name,
    common_name,
    last_name,
    gender,
    gender_identity,
    pronouns,
    appt_exclude_video,
    appt_video_optout_reason,
    appt_indigenous,
    date_of_birth,
    email,
    phone_number,
    street_address,
    province,
    city,
    postal_code,
    // doctor_id: doctor_id === "no-doctor" ? null : doctor_id,
    regular_family_doctor,
    family_doctor_if_yes:
      regular_family_doctor === 'yes' ? family_doctor_if_yes : '',
    medical_problem,
    medical_problem_if_yes:
      medical_problem === 'yes' ? medical_problem_if_yes : '',
    medications,
    medications_if_yes: medications === 'yes' ? medications_if_yes : '',
    allergies,
    allergies_if_yes: allergies === 'yes' ? allergies_if_yes : '',
    preferred_pharmacy,
    preferred_pharmacy_if_yes:
      preferred_pharmacy === 'yes' ? preferred_pharmacy_if_yes : '',
    referred_by_811,
    doctor_contacted,
    doctor_contacted_if_yes:
      doctor_contacted === 'yes' ? doctor_contacted_if_yes : '',

    appt_respiratory_illness,
    appt_symptom_fever,
    appt_shortness_of_breath,
    appt_abdominal_pain,
    appt_vomiting,
    appt_urinary_tract_infection,
    appt_rash,
    appt_wound_infection,
    appt_trauma_or_injury,
    appt_earache,
    appt_prescription_refill,
    appt_sick_note,
    appt_primary_care_needs,
    appt_discharged_from_hospital_in_14days,
    appt_please_describe_if_answered_yes,
    appt_reason_for_medical_visit_today,
    health_card_number,
    clinic_id: CLINIC_ID,
  }
  return updatedValues
}

export const fhirFirstVisit = (values) => {
  const fhirObject = {
    email: values.email,
    // "doctorId": values.doctor_id !== "no-doctor" ? values.doctor_id: null,
    patient: {
      // identifier: [
      //   {
      //     use: "example",
      //     type: {
      //       text: "Canadian Health Card Number",
      //       coding: [
      //         {
      //           code: "JHN",
      //           system: "http://terminology.hl7.org/CodeSystem/v2-0203",
      //         },
      //       ],
      //     },
      //     system: "http://terminology.hl7.org/CodeSystem/v2-0203",
      //     value: values.health_card_number,
      //   },
      // ],
      active: true,
      name: [
        {
          use: 'official',
          family: values.last_name,
          given: [values.first_name],
        },
        ...(values.common_name ? [{
          use: 'common',
          given: [values.common_name],
        }] : []),
      ],
      telecom: [
        {
          system: 'phone',
          value: values.phone_number,
          use: 'home',
          rank: 1,
        },
        {
          system: 'email',
          value: values.email,
          use: 'home',
          rank: 1,
        },
      ],
      gender: values.gender,
      ...(values.pronouns ? { pronouns: values.pronouns } : {}),
      birthDate: values.date_of_birth,
      deceasedBoolean: false,
      address: [
        {
          use: 'home',
          line: [values.street_address],
          city: values.city,
          state: values.province,
          country: 'Canada',
          postalCode: values.postal_code,
          type: 'physical',
        },
      ],
    },

    questionnaireResponse: {
      author: {
        type: 'Organization',
        reference: `${BASE_URL}/v1/organizations/${CLINIC_ID}`,
      },
      item: [
        {
          linkId: '1',
          text: 'Background',
          item: [
            {
              linkId: '1.1',
              text: 'Do you have a family doctor?',
              answer: [
                {
                  valueBoolean:
                    values.regular_family_doctor === 'yes' ? true : false,
                  item: [
                    {
                      text: "If yes to above, what is your family doctor's name?",
                      answer: [
                        {
                          valueString: values.family_doctor_if_yes,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              linkId: '1.2',
              text: 'Have you contacted your Family doctor?',
              answer: [
                {
                  valueBoolean:
                    values.doctor_contacted === 'yes' ? true : false,
                  item: [
                    {
                      text: 'If yes to above, Details of Contact?',
                      answer: [
                        {
                          valueString: values.doctor_contacted_if_yes,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              linkId: '1.3',
              text: 'Medical Problems',
              answer: [
                {
                  valueBoolean: values.medical_problem === 'yes' ? true : false,
                  item: [
                    {
                      text: 'If yes to above, please explain?',
                      answer: [
                        {
                          valueString: values.medical_problem_if_yes,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              linkId: '1.4',
              text: 'Medications',
              answer: [
                {
                  valueBoolean: values.medications === 'yes' ? true : false,
                  item: [
                    {
                      text: 'If yes to above, please explain?',
                      answer: [
                        {
                          valueString: values.medications_if_yes,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              linkId: '1.5',
              text: 'Allergies',
              answer: [
                {
                  valueBoolean: values.allergies === 'yes' ? true : false,
                  item: [
                    {
                      text: 'If yes to above, please explain?',
                      answer: [
                        {
                          valueString: values.allergies_if_yes,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              linkId: '1.6',
              text: 'Preferred Pharmacy',
              answer: [
                {
                  valueBoolean:
                    values.preferred_pharmacy === 'yes' ? true : false,
                  item: [
                    {
                      text: 'If yes to above, please explain?',
                      answer: [
                        {
                          valueString: values.preferred_pharmacy_if_yes,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          linkId: '1.7',
          text: 'Referred by 811',
          answer: [
            {
              valueBoolean: values.referred_by_811 === 'yes' ? true : false,
            },
          ],
        },
        {
          linkId: '2',
          text: 'Conditions',
          item: [
            {
              linkId: '2.1',
              text: 'Respiratory Illness',
              answer: [
                {
                  valueBoolean:
                    values.appt_respiratory_illness === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.2',
              text: 'Fever of 38° or greater',
              answer: [
                {
                  valueBoolean:
                    values.appt_symptom_fever === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.3',
              text: 'Shortness of breath or chest discomfort',
              answer: [
                {
                  valueBoolean:
                    values.appt_shortness_of_breath === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.4',
              text: 'Abdominal pain',
              answer: [
                {
                  valueBoolean:
                    values.appt_abdominal_pain === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.5',
              text: 'Vomiting',
              answer: [
                {
                  valueBoolean: values.appt_vomiting === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.6',
              text: 'Urinary Tract Infection',
              answer: [
                {
                  valueBoolean:
                    values.appt_urinary_tract_infection === 'yes'
                      ? true
                      : false,
                },
              ],
            },
            {
              linkId: '2.7',
              text: 'Rash',
              answer: [
                {
                  valueBoolean: values.appt_rash === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.8',
              text: 'Wound Infection',
              answer: [
                {
                  valueBoolean:
                    values.appt_wound_infection === 'yes' ? true : false,
                },
              ],
            },

            {
              linkId: '2.9',
              text: 'Trauma or Injury',
              answer: [
                {
                  valueBoolean:
                    values.appt_trauma_or_injury === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.10',
              text: 'Earache',
              answer: [
                {
                  valueBoolean: values.appt_earache === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.11',
              text: 'Prescription Refill',
              answer: [
                {
                  valueBoolean:
                    values.appt_prescription_refill === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.12',
              text: 'Sick Note',
              answer: [
                {
                  valueBoolean: values.appt_sick_note === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.13',
              text: 'Primary Care Needs',
              answer: [
                {
                  valueBoolean:
                    values.appt_primary_care_needs === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.14',
              text: 'If you answered yes to any of the question above, please describe',
              answer: [
                {
                  valueString: values.appt_please_describe_if_answered_yes,
                },
              ],
            },
          ],
        },
        {
          linkId: '3',
          text: 'What is the main reason for medical visit today?',
          answer: [
            {
              valueString: values.appt_reason_for_medical_visit_today,
            },
          ],
        },
        {
          linkId: '4',
          text: 'Additional Information',
          item: [
            {
              linkId: '4.1',
              text: 'Opt out of the video call for this visit?',
              answer: [
                {
                  valueBoolean:
                    values.appt_exclude_video === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '4.3',
              text: 'Reason for opting out?',
              answer: [
                {
                  valueString: values.appt_video_optout_reason,
                },
              ],
            },
            {
              linkId: '4.4',
              text: 'Identify as indigenous?',
              answer: [
                {
                  valueBoolean: values.appt_indigenous === 'yes' ? true : false,
                },
              ],
            },
          ],
        },
      ],
    },
  }
  fhirObject.patient.generalPractitioner = [
    {
      type: 'Organization',
      reference: `${BASE_URL}/v1/organizations/${CLINIC_ID}`,
    },
  ]

  fhirObject.patient.managingOrganization = {
    reference: `${BASE_URL}/v1/organizations/${CLINIC_ID}`,
    type: 'Organization',
  }

  if (values.gender_identity) {
    const selectedGenderIdentity = genderIdentityOptions.find(
      option => option.code === values.gender_identity
    );
    fhirObject.patient.genderIdentity = {
      coding: [
        {
          system: 'http://hl7.org/fhir/gender-identity',
          code: selectedGenderIdentity.code,
          display: selectedGenderIdentity.display,
        },
      ],
      text: selectedGenderIdentity.definition,
    }
  }

  if (values.blood_type && values.blood_type.value !== 'unknown') {
    console.log('Selected Blood Type:', values.blood_type);
    fhirObject.observation = {
      valueCodeableConcept: {
        coding: [
          {
            system: 'http://snomed.info/sct',
            code: values.blood_type,
            display: bloodTypes.find((item) => item.value === values.blood_type)
              .label,
          },
        ],
        text: 'blood',
      },
    }
  }

  if (values.health_card_number) {
    fhirObject.patient.identifier = [
      {
        use: 'example',
        type: {
          text: 'Canadian Health Card Number',
          coding: [
            {
              code: 'JHN',
              system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
            },
          ],
        },
        system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
        value: values.health_card_number,
      },
    ]
  }

  return fhirObject
}

export const fhirReVisit = (values) => {
  const fhirObject = {
    email: values.email,
    patient: {},

    questionnaireResponse: {
      author: {
        type: 'Organization',
        reference: `${BASE_URL}/v1/organizations/${CLINIC_ID}`,
      },
      item: [
        {
          linkId: '1',
          text: 'Background',
          item: [],
        },
        {
          linkId: '2',
          text: 'Conditions',
          item: [
            {
              linkId: '2.1',
              text: 'Respiratory Illness',
              answer: [
                {
                  valueBoolean:
                    values.appt_respiratory_illness === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.2',
              text: 'Fever of 38° or greater',
              answer: [
                {
                  valueBoolean:
                    values.appt_symptom_fever === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.3',
              text: 'Shortness of breath or chest discomfort',
              answer: [
                {
                  valueBoolean:
                    values.appt_shortness_of_breath === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.4',
              text: 'Abdominal pain',
              answer: [
                {
                  valueBoolean:
                    values.appt_abdominal_pain === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.5',
              text: 'Vomiting',
              answer: [
                {
                  valueBoolean: values.appt_vomiting === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.6',
              text: 'Urinary Tract Infection',
              answer: [
                {
                  valueBoolean:
                    values.appt_urinary_tract_infection === 'yes'
                      ? true
                      : false,
                },
              ],
            },
            {
              linkId: '2.7',
              text: 'Rash',
              answer: [
                {
                  valueBoolean: values.appt_rash === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.8',
              text: 'Wound Infection',
              answer: [
                {
                  valueBoolean:
                    values.appt_wound_infection === 'yes' ? true : false,
                },
              ],
            },

            {
              linkId: '2.9',
              text: 'Trauma or Injury',
              answer: [
                {
                  valueBoolean:
                    values.appt_trauma_or_injury === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.10',
              text: 'Earache',
              answer: [
                {
                  valueBoolean: values.appt_earache === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.11',
              text: 'Prescription Refill',
              answer: [
                {
                  valueBoolean:
                    values.appt_prescription_refill === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.12',
              text: 'Sick Note',
              answer: [
                {
                  valueBoolean: values.appt_sick_note === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.13',
              text: 'Primary Care Needs',
              answer: [
                {
                  valueBoolean:
                    values.appt_primary_care_needs === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '2.14',
              text: 'If you answered yes to any of the question above, please describe',
              answer: [
                {
                  valueString: values.appt_please_describe_if_answered_yes,
                },
              ],
            },
          ],
        },
        {
          linkId: '3',
          text: 'What is the main reason for medical visit today?',
          answer: [
            {
              valueString: values.appt_reason_for_medical_visit_today,
            },
          ],
        },
        {
          linkId: '4',
          text: 'Additional Information',
          item: [
            {
              linkId: '4.1',
              text: 'Opt out of the video call for this visit?',
              answer: [
                {
                  valueBoolean:
                    values.appt_exclude_video === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '4.2',
              text: 'Is this appointment related to last visit?',
              answer: [
                {
                  valueBoolean:
                    values.appt_related_last_visit === 'yes' ? true : false,
                },
              ],
            },
            {
              linkId: '4.3',
              text: 'Reason for opting out?',
              answer: [
                {
                  valueString: values.appt_video_optout_reason,
                },
              ],
            },
          ],
        },
      ],
    },
  }


  return fhirObject
}

export const getErrorMessage = (code) => {
  switch (code) {
    case 501:
      return 'Your email Does Not exist in our records, please use the First Time Visitor’s form to register.'
    default:
      return 'Something Went Wrong'
  }
}

export const calculateAge = (dateString) => {
  const today = new Date()
  const birthDate = new Date(dateString)
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDifference = today.getMonth() - birthDate.getMonth()
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--
  }
  return age
}
